export default __webpack_public_path__ + "static/media/img-gtl-du3.8407aa94.png";